import { Fragment, FunctionalComponent} from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { useSelector } from 'react-redux';

import { selectTotalShellsCounter, selectIsNewBottles } from '../../slice';
import { getTranslation } from '../../../../../shared/chromeApi';

import CounterPopover from './Popover';
import styles from './styles.module.scss';
import { selectUiMode } from '../../../../store/selectors';

const textStyles =
  typeof window === 'undefined' ? { color: 'transparent' } : {};

const Counter: FunctionalComponent = () => {
  const uiMode = useSelector(selectUiMode);
  const totalShellsCounter = useSelector(selectTotalShellsCounter);
  const isGainedBottles = useSelector(selectIsNewBottles);

  const bottlesCounter = Math.floor(totalShellsCounter / 100);
  const shellsCounter = totalShellsCounter % 100;

  const [state, setState] = useState({
    animateCounter: false,
    shellsGain: 0,
    bottlesCounter,
    shellsCounter,
    totalShellsCounter,
  });

  useEffect(() => {
    const bottlesGain = bottlesCounter - state.bottlesCounter;
    const shellsGain = totalShellsCounter - state.totalShellsCounter;

    if (!bottlesGain && !shellsGain) return;

    const animateCounter = isGainedBottles
      ? bottlesCounter > state.bottlesCounter
      : false;

    const newState = {
      bottlesCounter,
      shellsCounter,
      ...(uiMode !== 'focus' && {
        animateCounter,
        shellsGain,
        totalShellsCounter,
      })
    };

    setTimeout(() => setState(newState), 500);
    setTimeout(() => setState({ ...newState, animateCounter: false, shellsGain: null }), 3000);
  }, [totalShellsCounter]);

  return (
    <Fragment>
      <div
        className={`${styles.counterOuter} ${styles.shellsCounter} shellsCounterTC`}
      >
        <div>
          <div className={styles.counter}>
            <div className={`${styles.counterIcon} ${styles.shell}`} />
            <span style={textStyles}>{state.shellsCounter}</span>

            {!!state.shellsGain && (
              <span className={`${styles.plusOne} ${styles.animate}`}>
                +{state.shellsGain}
              </span>
            )}
          </div>

          <div className={styles.popover}>
            <div className={styles.outerPopover}>
              <div className={styles.innerPopover}>
                <p className={styles.description}>
                  {getTranslation('new_tab_shell_counter_description')}
                </p>

                <footer className={styles.footer}>
                  <div>
                    <a
                      className={styles.link}
                      href="https://about.oceanhero.today/shells-extension"
                    >
                      {getTranslation('new_tab_shell_counter_read')}
                    </a>
                  </div>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`${styles.counterOuter} ${styles.bottlesCounter} bottlesCounterTC`}
      >
        <Fragment>
          <div
            className={`${styles.counter} ${
              state.animateCounter ? styles.animate : ''
            }`}
          >
            <div className={`${styles.counterIcon} ${styles.bottle}`} />
            <span style={textStyles}>{state.bottlesCounter}</span>

            <div className={styles.pyro}>
              <div className={styles.before} />
              <div className={styles.after} />
            </div>
          </div>

          <CounterPopover />
        </Fragment>
      </div>
    </Fragment>
  );
};

export default Counter;
